import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GmMatColumnDef } from "../editable-table/GmMatColumnDef";
import { MatSort } from "@angular/material/sort";
import { ReaderService } from "../../services/reader.service";
import { Cycle, Region, Vehicle } from "../utility/utility-classes";
import { NewBodycycleComponent } from "../new-bodycycle/new-bodycycle.component";
import { NewPropulsionComponent } from "../new-propulsion/new-propulsion.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthenticationService } from "../authentication/authentication/authentication.service";
import { convertUtcToEst } from "../utility/time-conversion.util";

@Component({
    selector: "app-vehicle-subrecords",
    templateUrl: "./vehicle-subrecords.component.html",
    styleUrls: ["./vehicle-subrecords.component.scss"],
    standalone: false
})
export class VehicleSubrecordsComponent implements OnChanges {
  action: GmMatColumnDef = new GmMatColumnDef(
    "action",
    "Action",
    true,
    false,
    0,
    "",
    "text"
  );
  bodystyleData: MatTableDataSource<any[]> = new MatTableDataSource<any[]>();
  propulsionData: MatTableDataSource<any[]> = new MatTableDataSource<any[]>();
  bodystyleColumns: GmMatColumnDef[] = [];
  propulsionColumns: GmMatColumnDef[] = [];
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @Input() vehicle: Vehicle;
  @Input() edit = false;
  @Input() validRecord = false;
  @Output() saveRecord: EventEmitter<any> = new EventEmitter();
  convertUtcToEst = convertUtcToEst;

  constructor(
    public readerService: ReaderService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private authService: AuthenticationService
  ) {}

  ngOnChanges() {
    this.readerService.getAllFields("bodystyle").subscribe((hResponse) => {
      this.bodystyleColumns = hResponse;
      if (this.edit && this.authService.userInfo.admin) {
        this.bodystyleColumns.unshift(this.action);
      }
    });
    this.readerService.getAllFields("propulsion").subscribe((hResponse) => {
      this.propulsionColumns = hResponse;
      if (this.edit && this.authService.userInfo.admin) {
        this.propulsionColumns.unshift(this.action);
      }
    });

    if (this.vehicle.id !== undefined && this.vehicle.id != null) {
      this.readerService
        .getVehicleBodystyle(this.vehicle.id)
        .subscribe((bResonse) => {
          this.bodystyleData = new MatTableDataSource(bResonse);
          this.bodystyleData.sort = this.sort;
        });
      this.readerService
        .getVehiclePropulsions(this.vehicle.id)
        .subscribe((bResonse) => {
          this.propulsionData = new MatTableDataSource(bResonse);
          this.propulsionData.sort = this.sort;
        });
    }
  }

  createSubRecord(type: string) {
    if (this.vehicle.id == null) {
      this.snackBar.open(
        "Please save current Vehicle record to proceed",
        "OK",
        { duration: 5000 }
      );
      // matSnackBarRef.onAction().subscribe(() => {
      //   matSnackBarRef.dismissWithAction();
      //   // this.saveRecord.emit();
      //   // this.openDialog(type, { vehicle: this.vehicle });
      // });
    } else {
      this.openDialog(type, false, { vehicle: this.vehicle });
    }
  }

  duplicateRecord(type: string, record: any) {
    const regions: Region[] = []; //Intentionally keep regions null for the duplicate record
    const cycles: Cycle[] = [];

    this.extractRegions(type, record, cycles, regions);

    this.openDialog(type, false, {
      vehicle: this.vehicle,
      record,
      regions,
      cycles,
    });
  }

  editSubRecord(type: string, record: any) {
    const regions: Region[] = [];
    const cycles: Cycle[] = [];
    this.extractRegions(type, record, cycles, regions);
    this.openDialog(type, true, {
      vehicle: this.vehicle,
      record,
      regions,
      cycles,
    });
  }

  private extractRegions(
    type: string,
    record: any,
    cycles: Cycle[],
    regions: Region[]
  ) {
    switch (type) {
      case "bodystyle":
        this.processBodystyle(record, cycles, regions);
        break;

      case "propulsion":
        this.processPropulsion(record, regions);
        break;
    }
  }

  private processPropulsion(record: any, regions: Region[]) {
    if (record.regions != null) {
      record.regions.split(",,,").forEach((region) => {
        const xreg = region.split(":::");
        const thisRegion = xreg[0];
        this.propulsionColumns.forEach((column) => {
          if (column.header === thisRegion) {
            regions.push(
              new Region(
                record.id,
                this.propulsionColumns.filter(
                  (hdr) => hdr.header === thisRegion
                )[0].tooltip,
                xreg[1]
              )
            );
          }
        });
      });
    }
  }

  private processBodystyle(record: any, cycles: Cycle[], regions: Region[]) {
    if (record.cycles != null) {
      const dcycles = record.cycles.split(",");
      for (let k = 0; k < dcycles.length - 1; k++) {
        const xcycle = dcycles[k].split("-");
        cycles.push(new Cycle(xcycle[0], xcycle[1]));
      }
      while (cycles.length < 4) {
        cycles.push(new Cycle(null, null));
      }
      cycles.push(
        new Cycle(
          dcycles[dcycles.length - 1].split("-")[0],
          dcycles[dcycles.length - 1].split("-")[1]
        )
      );
    }
    if (record.regions != null) {
      record.regions.split(",,,").forEach((region) => {
        this.bodystyleColumns.forEach((column) => {
          if (column.includes(region)) {
            regions.push(
              new Region(
                record.id,
                this.bodystyleColumns.filter(
                  (hdr) => String(hdr) === region
                )[0].tooltip,
                true
              )
            );
          }
        });
      });
    }
  }

  private openDialog(type: string, editMode: boolean, data: any) {
    let dialogRef;
    switch (type) {
      case "bodystyle":
        dialogRef = this.dialog.open(NewBodycycleComponent, {
          data: {
            editMode,
            entry: data,
          },
          autoFocus: false,
        });
        break;
      case "propulsion":
        dialogRef = this.dialog.open(NewPropulsionComponent, {
          data: {
            editMode,
            entry: data,
          },
          autoFocus: false,
        });
        break;
    }
    // Refresh the component after closing the dialog!
    dialogRef.afterClosed().subscribe(() => {
      this.ngOnChanges();
    });
  }
}
